module.exports = __webpack_public_path__ + "img/2022-mid-autumn-festival.697e1d56.jpg";